let getCounterpartTypeLabel = function (type) {
  let typeLabel = '';
  if (type === 'supplier') {
    typeLabel = 'Поставщик'
  } else if  (type === 'customer') {
    typeLabel = 'Покупатель'
  } else if (type==='user') {
    typeLabel = 'Пользователь'
  } else if (type==='account') {
    typeLabel = 'Счет'
  }
  return typeLabel;
};

let getRouteNameByCounterpartType = function (type) {
  let routeName = '';
  if (type === 'supplier') {
    routeName = 'supplier_detail'
  } else if  (type === 'customer') {
    routeName = 'customer_detail'
  } else if (type==='user') {
    routeName = 'user_detail'
  } else if (type==='account') {
    routeName = 'account_detail'
  }
  return routeName;
};

export {
  getCounterpartTypeLabel,
  getRouteNameByCounterpartType
};



// WEBPACK FOOTER //
// ./src/apps/money_order/func.js